export const rulesetFormThem = {
  error: 'palette.error.70',
  hint: 'palette.primary.60',
};
